import { useState } from 'react';
import { ImageOff } from 'lucide-react';

interface Props {
  src: string | null;
  /** Empty for a decorative image (the title is printed right beside it). */
  alt: string;
  className: string;
}

/** A preview image, or a neutral placeholder when there is none or it fails to load. */
export function PackArt({ src, alt, className }: Props) {
  const [broken, setBroken] = useState(false);

  if (!src || broken) {
    return (
      <div
        className={`flex items-center justify-center bg-[var(--co-bg)] text-[var(--co-muted)] ${className}`}
        {...(alt ? { role: 'img', 'aria-label': alt } : { 'aria-hidden': true })}
      >
        <ImageOff size={24} aria-hidden="true" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setBroken(true)}
      className={`bg-[var(--co-bg)] object-contain ${className}`}
    />
  );
}
